export default __webpack_public_path__ + "static/media/spiritswap.f9cfa65a.svg";